import { MainApplicationProviderWrapper } from 'Components/AppLayout';

import { createRoot } from 'react-dom/client';
import { brdRoutes } from './routes';

createRoot(document.getElementById('content')).render(
  <MainApplicationProviderWrapper appRoutes={brdRoutes} />,
);
